import {
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  CheckAuthResponse,
} from "../types/auth";
import { api } from "./api";

export const authService = {
  /**
   * 로그인
   * POST /api/login
   * Content-Type: application/x-www-form-urlencoded
   */
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    try {
      console.log("🔐 로그인 시작:", data.username);

      const params = new URLSearchParams({
        username: data.username,
        password: data.password,
      });

      const response = await api.post<LoginResponse>("/api/login", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        withCredentials: true, // JSESSIONID 쿠키 자동 저장
      });

      console.log("✅ 로그인 성공:", response.data);
      return response.data;
    } catch (err) {
      console.error("❌ 로그인 실패:", err);
      throw err;
    }
  },

  /**
   * 로그아웃
   * POST /api/logout
   * 세션 무효화 후 JSESSIONID 쿠키 삭제
   */
  logout: async (): Promise<LogoutResponse> => {
    try {
      console.log("🚪 로그아웃 시작");

      const response = await api.post<LogoutResponse>("/api/logout", null, {
        withCredentials: true,
      });

      console.log("✅ 로그아웃 성공:", response.data);
      return response.data;
    } catch (err) {
      console.error("❌ 로그아웃 실패:", err);
      throw err;
    }
  },

  /**
   * 로그인 상태 확인
   * GET /api/check-auth
   * 세션이 유효하면 200 + 유저 정보, 만료/미로그인이면 200 + success:false 반환
   */
  checkAuth: async (): Promise<CheckAuthResponse> => {
    try {
      const response = await api.get<CheckAuthResponse>("/api/check-auth", {
        withCredentials: true,
      });

      console.log("🔍 세션 확인:", response.data);
      return response.data;
    } catch (err) {
      console.error("❌ 세션 확인 실패:", err);
      throw err;
    }
  },

  /**
   * 로그인 상태 확인 (로컬 체크)
   */
  isAuthenticated: async (): Promise<boolean> => {
    try {
      const response = await authService.checkAuth();
      return response.success;
    } catch {
      return false;
    }
  },
};
